module.exports = __webpack_public_path__ + "static/travel3-23d30070d61ff953d4423a94743267d0.mp4";